<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <div class="mb-10" v-if="model.id == null">
        <div class="">
          <div class="flex gap-4 items-center">
            <vs-input
              class="inputx mb-1 w-1/2"
              v-model="model.code"
              type="number"
              name="AccountCode"
              :label="$t('AccountCode')"
              v-validate="'required'"
            />
            <div v-if="parentId" class="mt-5 flex w-1/2">
              <span style="direction: ltr">{{ parentCode }} _</span>
            </div>
          </div>
          <span
            class="text-danger text-sm"
            v-show="errors.has('AccountCode')"
            >{{ errors.first("AccountCode") }}</span
          >
        </div>
        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.title"
          name="AccountFloatingTitle"
          :label="$t('AccountFloatingTitle')"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('AccountFloatingTitle')"
          >{{ errors.first("AccountFloatingTitle") }}</span
        >
        <vs-textarea
          rows="5"
          class="mt-4"
          name="Description"
          :label="$t('Description')"
          v-model="model.description"
        />
      </div>

      <vs-button
        v-if="model.id != null"
        type="filled"
        class="float-right mb-4 mt-12"
        @click.prevent="submitForm"
        >{{ $t("Save") }}</vs-button
      >
      <vs-button
        v-else
        type="filled"
        class="float-right mb-4"
        :class="model.id != null ? 'mt-12' : ''"
        @click.prevent="submitForm"
        :disabled="!model.title"
        >{{ $t("Save") }}</vs-button
      >
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "@/components/CustomVSelect.vue";

const dict = {
  custom: {
    AccountFloatingTitle: {
      required: "لطفا عنوان حساب شناوری را وارد نمایید.",
    },
    AccountCode: {
      required: "لطفا کد حساب را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  components: {
    "v-select": vSelect,
  },
  props: {
    show: { default: false },
    model: {
      default: {},
    },
    parentId: 0,
    parentCode: '',

    products: null,
  },
  data() {
    return {
      AccountTitle: "",
      popupTitle: "",
      accountName: "",
      disabled: false,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },

  methods: {
    ...mapActions({
      createAccount: "floatingAccount/create",
      updateAccount: "floatingAccount/update",
    }),

    submitForm() {
      this.$validator.validateAll().then((result) => {
        this.disabled = true;
        if (result) {
          this.model.parentAccountId = this.parentId;
          this.createAccount(this.model).then(() => {
            this.$emit("finish");
            this.model = {};
            this.$validator.reset();
            this.disabled = false;
          });
        } else {
          // form have errors
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.disabled = false;

        if (this.model.id) this.popupTitle = "EditFloatingAccount";
        else this.popupTitle = "CreateNewFloatingAccount";
      }
      this.$validator.reset();
    },
  },
};
</script>
<style></style>
